import React from 'react';

import classNames from 'classnames';

import { EXCEPTION_CELL_CLASS, OpenRowButton, orNotSet } from '../HomeSection';

import { isRedRag, RagBadge, StatusBadge } from './rowBadges';

/**
 * The user's risks, with the register's own columns.
 *
 * TWO RAG COLUMNS, raw and controlled. A register that scores every risk twice
 * — before mitigation and after it — and then shows one number has thrown away
 * the comparison that is the point of scoring it twice.
 *
 * BOTH ARE LABELLED PILLS, not the register's bare colour blocks. See RagBadge.
 *
 * A RED-RATED RISK ALSO CARRIES THE LEADING RULE every other list marks its
 * exceptions with. The pill alone is not enough: a user scanning the panel's
 * leading edge for what is wrong would pass over risks entirely, on the one
 * list whose exception the attention strip leads with.
 */
export default function RiskSectionTable({ rows = [], onRowClick }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Description')}</th>
                        <th>{$t('Type')}</th>
                        <th>{$t('Status')}</th>
                        <th className="tw-w-28">{$t('RAG')}</th>
                        <th className="tw-w-28">{$t('RAG Controlled')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id} onClick={() => onRowClick?.(row)} className="tw-cursor-pointer">
                            <td className={classNames({ [EXCEPTION_CELL_CLASS]: isRedRag(row.rag) })}>
                                <OpenRowButton onClick={() => onRowClick?.(row)} label={$t('Open {{item}}', { item: row.description })}>
                                    {row.description}
                                </OpenRowButton>
                            </td>
                            <td>{orNotSet(row.type)}</td>
                            <td>
                                <StatusBadge status={row.status} />
                            </td>
                            <td>
                                <RagBadge rag={row.rag} />
                            </td>
                            <td>
                                <RagBadge rag={row.rag_controlled} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
